export const GET_ROLES = "app/Roles/GET_ROLES";
export const GET_ROLES_PENDING = "app/Roles/GET_ROLES_PENDING";
export const GET_ROLES_SUCCESS = "app/Roles/GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "app/Roles/GET_ROLES_FAILURE";
export const OPEN_ADD_MODEL = "app/Roles/OPEN_ADD_MODEL";
export const ROLES_EDIT_MODEL_START_FETCH =
  "app/Roles/ROLES_EDIT_MODEL_START_FETCH";
export const ROLES_VIEW_MODEL_START_FETCH =
  "app/Roles/ROLES_VIEW_MODEL_START_FETCH";

export const ROLES_CLOSE_ADD_MODAL = "app/Roles/CLOSE_ADD_MODAL";
export const ROLES_EDIT_MODAL_OPEN_AND_FETCH =
  "app/Roles/EDIT_MODAL_OPEN_AND_FETCH";
export const ROLES_CLOSE_EDIT_MODAL = "app/Roles/CLOSE_EDIT_MODAL";
export const ROLES_VIEW_MODAL_OPEN_AND_FETCH =
  "app/Roles/VIEW_MODAL_OPEN_AND_FETCH";
export const ROLES_MODAL_SET_ROLE = "app/Roles/MODAL_SET_ROLE";
export const ROLES_CLOSE_VIEW_MODAL = "app/Roles/CLOSE_VIEW_MODAL";
export const ROLES_OPEN_ADD_MODAL = "app/Roles/ROLES_OPEN_ADD_MODAL";

export const ROLE_SAVE_PENDING = "app/Roles/ROLE_SAVE_PENDING";
export const ROLE_SAVE_SUCCESS = "app/Roles/ROLE_SAVE_SUCCESS";
export const ROLE_SAVE_FAILURE = "app/Roles/ROLE_SAVE_FAILURE";
export const ROLE_SAVE = "app/Roles/ROLE_SAVE";

export const ROLE_EDIT_PENDING = "app/Roles/ROLE_EDIT_PENDING";
export const ROLE_EDIT_SUCCESS = "app/Roles/ROLE_EDIT_SUCCESS";
export const ROLE_EDIT_FAILURE = "app/Roles/ROLE_EDIT_FAILURE";
export const ROLE_EDIT = "app/Roles/ROLE_EDIT";

export const DELETE_ROLE_PENDING = "app/Roles/DELETE_ROLE_PENDING";
export const DELETE_ROLE_SUCCESS = "app/Roles/DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILURE = "app/Roles/DELETE_ROLE_FAILURE";
export const DELETE_ROLE = "app/Roles/DELETE_ROLE";
